<template>
  <f7-block class="root" strong>
    <div class="comment" v-if="entry.type === 'comment'">
      <f7-block-header>{{this.name}} commented</f7-block-header>
      <p>{{entry.body}}</p>
    </div>
    <div v-if="entry.type === 'tag-added'">
      <f7-block-header>{{this.name}} added tag <span class="tag">{{entry.body}}</span></f7-block-header>
    </div>
    <div v-if="entry.type === 'tag-removed'">
      <f7-block-header>{{this.name}} removed tag <span class="tag">{{entry.body}}</span></f7-block-header>
    </div>
    <div v-if="entry.type === 'tag-set'">
      <f7-block-header>{{this.name}} changed tags:</f7-block-header>
      <f7-block-footer v-if="entry.added.length">added:
        <tag-chip v-for="tag in entry.added" :tag="tag" :key="tag.name" compact no-click/>
      </f7-block-footer>
      <f7-block-footer v-if="entry.removed.length">removed:
        <tag-chip v-for="tag in entry.removed" :tag="tag" :key="tag.name" compact no-click/>
      </f7-block-footer>
    </div>
    <div v-if="entry.type === 'approved'">
      <f7-block-header>{{this.name}} approved this request</f7-block-header>
    </div>
    <div v-if="entry.type === 'declined'">
      <f7-block-header>{{this.name}} declined this request</f7-block-header>
    </div>
    <f7-block-footer>{{this.created}}</f7-block-footer>
  </f7-block>
</template>

<script>
  import helpers from "@/utils/helpers";
  import TagChip from '@/components/TagChip'

  /*
  Example entries:
      {created: 1568808396535, type: 'comment', user: 138, body: 'Yeah'},
      {created: 1568808396535, type: 'tag', user: 105, tag: 'whack'},
      {created: 1568808396535, type: 'approval', user: 13},

  Expect more types of entry to work in future e.g.:
      * disapproval
      * tag removal
      * bot activity?
  */

  export default {
    name: "activity-feed-entry",
    components: {TagChip},
    mixins: [helpers],
    props: {
      entry: Object,
    },
    computed: {
      created () {
        return this.toDateTime(this.entry.created);
      },
      user () {
        // This would get slow in a large organization, should probably put together a mapping or something
        return this.myTeam.find(u => u.id === this.entry.user);
      },
      name () {
        return this.userName(this.user);
      },
    },
  }
</script>

<style lang="scss" scoped>
  // div.root because specificity
  // TODO: make these the same height?
  div.root {
    margin: 0 0;

    &::before {
      background-color: transparent;
    }
  }

  .comment {
    white-space: pre;
  }

</style>
